import React from 'react';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import './OrderCancelled.less';

const OrderCancelled = ({ orderData }) => {
	const { start_time, end_time, meal_name, drink_name, price, display_id, order_customizations } = orderData;
	const drinkCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'drink') : null;
	const mealCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'meal') : null;

	const total = price + order_customizations.reduce((sum, item) => sum + item.option_price || 0, 0);

	return (
		<div className="order-removed">
			<div className="order-removed-header">
				<div className="order-removed-icon-wrapper">
					<FontAwesomeIcon
						icon={faExclamationTriangle}
						className="order-removed-icon"
					/>
				</div>
				<h2 className="order-removed-title">訂單已取消 Order Cancelled</h2>
				{/* <p className="order-removed-subtitle">
					This order has been cancelled by the administrator. If you believe this is an error, please contact support.
				</p> */}
			</div>

			<div className="order-details-section">
				<div className="order-status-badge removed">
					<span>已取消Cancelled</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單編號 Order ID</span>
					<span className="detail-value">{display_id}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">取餐時段 Pickup Timeslot</span>
					<span className="detail-value">{start_time && end_time ? `${dayjs(start_time).format('HH:mm')} - ${dayjs(end_time).format('HH:mm')}` : 'N/A'}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單摘要 Order Summary</span>
					<div className="detail-value">
						<div>• {meal_name}</div>
						{mealCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{mealCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
						{drink_name && <div>• {drink_name}</div>}
						{drinkCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{drinkCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
					</div>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">總額 Total</span>
					<span className="detail-value">${total.toFixed(2)}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">需要協助？Need help?</span>
					<span className="detail-value">• 如對訂單有任何疑問，請聯絡我們的收銀員。If you have any questions about the removal, please contact our cashier.</span>
				</div>
			</div>
		</div>
	);
};

export default OrderCancelled;
